/**
 *  @Author : Luo
 *  @Time   : 2020/4/1 10:11
 *  js fun of common
 **/

/**
 * newMap: 返回一个新的数组（当数组中元素是值类型，map不会改变原数组；若是引用类型，则可以改变原数组。注：map方法体现的是数据不可变的思想。该思想认为所有的数据都是不能改变的，只能通过生成新的数据来达到修改的目的，因此直接对数组元素或对象属性进行操作的行为都是不可取的。）
 */

let newMap = (arr, fun) => {
  if (typeof fun !== 'function') fun = () => {}

  return arr.map((i, index) => {
    let item = { ...i }
    fun(item, index)
    return item
  })
}

/**
 * objSort: 仅支持一维数组，需自行比较(increment: 递增, decrement: 递减)
 * @param options(object) 需要的参数，目前支持arr:数组、type:格式（数组所有项的格式）、sequence:序列（递增或递减）
 * @returns array 返回排序后的数组
 */
let objSort = (options) => {
  if (typeof options === 'undefined') options = []

  let newArr = [ ...options.arr ]

  if (typeof newArr === 'undefined') newArr = []

  if (typeof options.sequence === 'undefined') options.sequence = 'decrement'

  if (typeof options.type === 'number') options.type = 'string'

  /**
   * number类型不管是字符类型的数字还是number类型的数字都转换为number类型的数字人后比较大下
   * 字符串比较前全部再次转换为字符串通过localeCompare(str)对首字母进行比较（ps：a.localeCompare(b)返回0:a=b，-1:a<b,1:a>b）
   * recursive（递归）
   * @param arr (Array)
   * @returns {Array}
   */
  let recursive = (arr) => {
    let len = arr.length - 1
    let nextVal
    let prevVal

    for (let j = 0; j < len; j++) {
      for (let i = 0; i < len - j; i++) {
        if (options.type === 'number') {
          nextVal = Number(arr[i + 1])
          prevVal = Number(arr[i])

          if (options.sequence === 'decrement') {
            if (prevVal <= nextVal) [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
          } else if (options.sequence === 'increment') {
            if (prevVal >= nextVal) [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
          }
        } else if (options.type === 'string') {
          nextVal = arr[i].toString().localeCompare(arr[i + 1])
          if (options.sequence === 'decrement') {
            if (nextVal < 0) [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
          } else if (options.sequence === 'increment') {
            if (nextVal > 0) [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
          }
        }
      }
    }
  }

  recursive(newArr)

  return newArr
}

/**
 * 查找指定父元素下的所有的子节点（使用闭包查询或者叫递归）
 * @param arr（object） 当前父元素下的子元素
 * @param str (需要查找的class)
 * @returns array
 */
let findChildClass = (arr, str) => {
  let newArr = []

  if (typeof str !== 'string' && typeof arr !== 'object') return newArr

  let recursive = (arr) => {
    for (let item of arr) {
      if (item.children.length > 0) {
        if (item.classList.value.indexOf(str) > -1) newArr.push(item)

        if (item.children) recursive(item.children)
      }
    }
  }

  recursive(arr)

  return newArr
}

/**
 * 设置千分位
 */
let setThousandths = (num) => {
  return num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

/**
 * storage
 * @type {{removeItem: setStorage.removeItem, getStorage: (function(): *), clear: setStorage.clear, getItem: (function(*=): (*|DOMPoint|SVGTransform|SVGNumber|string|SVGLength|SVGPathSeg)), setItem: setStorage.setItem}}
 * 本地存储
 */
let setStorage = {
  storage: window.localStorage,
  setItem: function (k, v) {
    this.storage.setItem(k, v)
  },
  getItem: function (k) {
    return this.storage.getItem(k)
  },
  getStorage: function () {
    return this.storage
  },
  removeItem: function (str) {
    this.storage.removeItem(str)
  },
  clear: function () {
    this.storage.clear()
  }
}

/**
 * setTimeType
 * @param n
 * @returns {string}
 * 设置时间格式为（时：分：秒）
 */
let setTimeType = (n) => {
  n = Math.ceil(n)
  let tempHour = Math.floor(n / 3600)
  let tempMin = Math.floor(n % 3600 / 60)
  let tempSecond = n % 60
  return (tempHour < 10 ? '0' + tempHour : tempHour) +
    ':' + (tempMin < 10 ? '0' + tempMin : tempMin) +
    ':' + (tempSecond < 10 ? '0' + tempSecond : tempSecond)
}

/**
 * @param n
 * @returns {function(*): number}
 * 设置一些特殊的数字  ex: 0.07 * 100 = 7.000000000000001
 */
let resetSpecNum = (n) => {
  n = Number(n)
  return parseFloat((n * 100).toPrecision(12))
}

/**
 * 设置时间（年月日）
 * @param {*} t
 * @param {*} s
 * @returns string
 */
const setDateType = (t, s = '-') => {
  if (!t) return '-'
  let a = new Date(t)
  return a.getFullYear() + s + (a.getMonth() > 8 ? '' : '0') + (a.getMonth() + 1) + s + (a.getDate() > 9 ? '' : '0') + a.getDate()
}

/**
 * 设置时分秒
 * @param {*} t 时间（毫秒）
 * @param {*} str （分割字符）
 * @returns string
 */
const setDateSecond = (t, str = ':') => {
  if (!t) return '-'

  t = new Date(t)

  const h = t.getHours()
  const m = t.getMinutes()
  const s = t.getSeconds()

  return (h < 10 ? '0' : '') + h + str + (m < 10 ? '0' : '') + m + str + (s < 10 ? '0' : '') + s
}

/**
 * 设置开始时间
 * @param {Date} 时间
 * @returns Date
 */
const setStartDate = (t) => {
  if (!t) return '-'
  const newDate = new Date(setDateType(t, '/')).getTime()
  return setDateType(newDate) + ' ' + setDateSecond(newDate)
}

/**
 * 设置结束时间
 * @param {Date} 时间
 * @returns Date
 */
const setEndDate = (t) => {
  if (!t) return '-'
  const dayTime = 24 * 60 * 60 * 1000 - 1
  const newDate = new Date(setDateType(t, '/')).getTime() + dayTime
  return setDateType(newDate) + ' ' + setDateSecond(newDate)
}

export {
  newMap,
  objSort,
  findChildClass,
  setThousandths,
  setStorage,
  setTimeType,
  setDateType,
  setDateSecond,
  resetSpecNum,
  setEndDate,
  setStartDate
}



// WEBPACK FOOTER //
// ./src/components/common/common_js.js